module.exports = __webpack_public_path__ + "img/cirrus@2x.0c3f17b6.png";